import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

class PettyCash extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            amount: "",
            category: null,
            payMethod: null,
            remark: "",
            transactionType: "Pay Out",
            filterType: "All",
            transactions: []
        };
    }

    categories = [
        { label: "Office Expense", value: "Office Expense" },
        { label: "Travel", value: "Travel" },
        { label: "Food", value: "Food" },
        { label: "Others", value: "Others" }
    ];

    payMethods = [
        { label: "Cash", value: "Cash" },
        { label: "Card", value: "Card" },
        { label: "UPI", value: "UPI" }
    ];

    handleSave = () => {

        const {
            name,
            amount,
            category,
            payMethod,
            remark,
            transactionType,
            transactions
        } = this.state;

        if (!name || !amount) {
            alert("Please fill Name and Amount");
            return;
        }

        const newTransaction = {
            id: Date.now(),
            name,
            type: transactionType,
            amount,
            category: category ? category.value : "",
            payMethod: payMethod ? payMethod.value : "",
            remark
        };

        this.setState({
            transactions: [newTransaction, ...transactions],
            name: "",
            amount: "",
            category: null,
            payMethod: null,
            remark: ""
        });
    };

    handleDelete = (id) => {

        this.setState({
            transactions: this.state.transactions.filter(
                t => t.id !== id
            )
        });

    };

    handlePrint = (transaction) => {

        alert(
            `Printing : ${transaction.name} - ${transaction.amount}`
        );

    };

    render() {

        const { transactions } = this.state;

        const totalPayOut = transactions
            .filter(t => t.type === "Pay Out")
            .reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);

        const totalPayIn = transactions
            .filter(t => t.type === "Pay In")
            .reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);

        const { filterType } = this.state;

        const filteredTransactions =
            filterType === "All"
                ? transactions
                : transactions.filter(item => item.type === filterType);






        return (
            <div className="p-grid p-m-0" >

                {/* Left Side */}

                {/* <div className="p-col-12 p-lg-6">

                <div className="p-shadow-2 p-p-4"> */}

                <div className="p-col-12 p-lg-6" >

                    <div className="p-shadow-2 p-p-4">

                        <h2 className="p-text-center p-mb-5">
                            Add In / Out Transactions
                        </h2>

                        <div className="p-grid p-ai-center p-mb-3">

                            <label className="p-col-12 p-md-4">
                                Name
                            </label>

                            <div className="p-col-12 p-md-8">
                                <InputText
                                    value={this.state.name}
                                    onChange={(e) =>
                                        this.setState({
                                            name: e.target.value
                                        })
                                    }
                                    className="p-col-12"
                                />
                            </div>

                        </div>

                        <div className="p-grid p-ai-center p-mb-3">

                            <label className="p-col-12 p-md-4">
                                Transaction Type
                            </label>

                            <div className="p-col-12 p-md-8">



                                {/* <Button
                                label="Pay Out"
                                className="p-button-warning p-mr-2"
                                onClick={() => setTransactionType("Pay Out")}
                            />

                            <Button
                                label="Pay In"
                                className="p-button-primary"
                                onClick={() => setTransactionType("Pay In")}
                            /> */}

                                <Button
                                    label="Pay Out"
                                    className={
                                        this.state.transactionType === "Pay Out"
                                            ? "p-button-secondary p-mr-2"
                                            : "p-button-outlined p-mr-2"
                                    }
                                    onClick={() =>
                                        this.setState({
                                            transactionType: "Pay Out"
                                        })
                                    }
                                />

                                <Button
                                    label="Pay In"
                                    className={
                                        this.state.transactionType === "Pay In"
                                            ? "p-button-secondary p-mr-2"
                                            : "p-button-outlined p-mr-2"
                                    }
                                    onClick={() =>
                                        this.setState({
                                            transactionType: "Pay In"
                                        })
                                    }
                                />


                                {/* {transactionType === "Pay Out" && (
                                <Button
                                    label="Pay Out"
                                    className="p-button-primary"
                                    onClick={() => setTransactionType("Pay In")}
                                />
                            )}

                            {transactionType === "Pay In" && (
                                <Button
                                    label="Pay In"
                                    className="p-button-danger"
                                    onClick={() => setTransactionType("Pay Out")}
                                />
                            )} */}


                            </div>

                        </div>

                        <div className="p-grid p-ai-center p-mb-3">

                            <label className="p-col-12 p-md-4">
                                Amount
                            </label>

                            <div className="p-col-12 p-md-8">

                                <InputText
                                    value={this.state.amount}
                                    onChange={(e) =>
                                        this.setState({
                                            amount: e.target.value
                                        })
                                    }
                                    className="p-col-12"
                                />

                            </div>

                        </div>

                        <div className="p-grid p-ai-center p-mb-3">

                            <label className="p-col-12 p-md-4">
                                Category
                            </label>

                            <div className="p-col-12 p-md-8">

                                <Dropdown
                                    value={this.state.category}
                                    options={this.categories}
                                    onChange={(e) =>
                                        this.setState({
                                            category: e.value
                                        })
                                    }
                                    className="p-col-12"
                                    placeholder="Select Category"
                                />

                            </div>

                        </div>

                        <div className="p-grid p-ai-center p-mb-3">

                            <label className="p-col-12 p-md-4">
                                Pay Method
                            </label>

                            <div className="p-col-12 p-md-8">

                                <Dropdown
                                    value={this.state.payMethod}
                                    options={this.payMethods}
                                    onChange={(e) =>
                                        this.setState({
                                            payMethod: e.value
                                        })
                                    }
                                    className="p-col-12"
                                    placeholder="Select Pay Method"
                                />

                            </div>

                        </div>

                        <div className="p-grid p-mb-3">

                            <label className="p-col-12 p-md-4">
                                Remark
                            </label>

                            <div className="p-col-12 p-md-8">

                                <InputTextarea
                                    value={this.state.remark}
                                    onChange={(e) =>
                                        this.setState({
                                            remark: e.target.value
                                        })
                                    }
                                    className="p-col-12"
                                />

                            </div>

                        </div>

                        <div className="p-d-flex p-jc-end">

                            <Button
                                label="Save"
                                icon="pi pi-check"
                                onClick={this.handleSave}
                            />

                        </div>






                    </div>

                </div>

                {/* Right Side */}

                < div className="p-col-12 p-lg-6" >

                    <div className="p-shadow-2 p-p-4">

                        <h2 className="p-text-center p-mb-5">
                            List In / Out Transactions
                        </h2>

                        {/* <div className="p-d-flex p-jc-center p-mb-3">

                        <Button
                            label={`All (${transactions.length})`}
                            className="p-button-primary p-mr-2"
                        />

                        <Button
                            label={`Pay Out (${transactions.filter(t => t.type === "Pay Out").length})`}
                            className="p-button-primary p-mr-2"
                        />

                        <Button
                            label={`Pay In (${transactions.filter(t => t.type === "Pay In").length})`}
                            className="p-button-primary"
                        />

                    </div> */}

                        {/* <div className="p-d-flex p-jc-center p-mb-3">

                            <Button
                                label={`All (${this.state.transactions.length})`}
                                className={
                                    this.state.filterType === "All"
                                        ? "p-button-secondary p-mr-2"
                                        : "p-button-outlined p-mr-2"
                                }
                                onClick={() =>
                                    this.setState({
                                        filterType: "All"
                                    })
                                }
                            />

                            <Button
                                label={`Pay In (${this.state.transactions.length})`}
                                className={
                                    this.state.filterType === "Pay Out"
                                        ? "p-button-secondary p-mr-2"
                                        : "p-button-outlined p-mr-2"
                                }
                                onClick={() =>
                                    this.setState({
                                        filterType: "Pay Out"
                                    })
                                }
                            />

                            <Button
                                label={`Pay Out (${this.state.transactions.length})`}
                                className={
                                    this.state.filterType === "Pay In"
                                        ? "p-button-secondary p-mr-2"
                                        : "p-button-outlined p-mr-2"
                                }
                                onClick={() =>
                                    this.setState({
                                        filterType: "Pay In"
                                    })
                                }
                            />

                        </div> */}

                        <div className="p-d-flex p-jc-center p-mb-3">

                            <Button
                                label={`All (${transactions.length})`}
                                className={
                                    this.state.filterType === "All"
                                        ? "p-button-secondary p-mr-2"
                                        : "p-button-outlined p-mr-2"
                                }
                                onClick={() =>
                                    this.setState({
                                        filterType: "All"
                                    })
                                }
                            />

                            <Button
                                label={`Pay In (${transactions.filter(t => t.type === "Pay In").length})`}
                                className={
                                    this.state.filterType === "Pay In"
                                        ? "p-button-secondary p-mr-2"
                                        : "p-button-outlined p-mr-2"
                                }
                                onClick={() =>
                                    this.setState({
                                        filterType: "Pay In"
                                    })
                                }
                            />

                            <Button
                                label={`Pay Out (${transactions.filter(t => t.type === "Pay Out").length})`}
                                className={
                                    this.state.filterType === "Pay Out"
                                        ? "p-button-secondary"
                                        : "p-button-outlined"
                                }
                                onClick={() =>
                                    this.setState({
                                        filterType: "Pay Out"
                                    })
                                }
                            />

                        </div>

                        <DataTable
                            value={filteredTransactions}
                            responsiveLayout="scroll"
                        >

                            <Column field="name" header="Name" />
                            <Column field="type" header="Type" />
                            <Column field="amount" header="Amount" />
                            <Column field="category" header="Category" />
                            <Column field="payMethod" header="Pay Method" />
                            <Column field="remark" header="Remark" />

                        </DataTable>

                        <div className="p-d-flex p-jc-between p-mt-3">

                            <strong>
                                Total Pay Out : {totalPayOut}
                            </strong>

                            <strong>
                                Total Pay In : {totalPayIn}
                            </strong>

                        </div>

                    </div>

                </div >

            </div >
        );
    };
}

export default PettyCash;